export enum InviteStatus {
    OPEN = 'OPEN',
    WAITING_CONFIRMATION = 'WAITING_CONFIRMATION',
    CONFIRMED = 'CONFIRMED',
    CLOSED = 'CLOSED'
}